// Invitanda pass 74 (2026-10-23): moved out of snippets/mb-sheet, where it was printed inline on every view of the page.

(function () {
  if (window.__mbSheet) return;
  window.__mbSheet = 1;
  var opener = null, y0 = 0, old = null, keepY = false, hold = false;
  function D() { return document.getElementById('mb-sheet'); }
  function key(p) { p = String(p || '').replace(/\/+$/, ''); var m = p.match(/\/(products|pages|policies)\/[^\/]+$/); return m ? m[0] : p; }
  function tpls() { return Array.prototype.slice.call(document.querySelectorAll('template[data-mbs-tpl], template[data-mbs-self]')); }
  function byId(id) { return tpls().filter(function (t) { return t.getAttribute('data-mbs-tpl') === id; })[0] || null; }
  function byPath(p) { var k = key(p); return tpls().filter(function (t) { return key(t.getAttribute('data-mbs-path')) === k; })[0] || null; }
  function inZone(el) {
    if (el.closest('.product-details, #table-bags, [data-mbal]')) return true;
    var a = document.getElementById('other_designs'), s = (a && a.closest('.shopify-section')) || document.querySelector('.shopify-section[id$="__other_designs"]');
    return !!s && s.contains(el);
  }
  function unlock() {
    var h = document.documentElement;
    if (old) { h.style.overflow = old.o; h.style.paddingRight = old.p; old = null; }
    // After an in-place action the listener has already put the page where the tapped card stays under her finger.
    if (!keepY && Math.abs(window.scrollY - y0) > 1) window.scrollTo(0, y0);
    keepY = false;
  }
  function close() { var d = D(); if (d && d.open) d.close(); }
  function onClose() {
    var d = D(), b = d && d.querySelector('[data-mbs-body]');
    if (b) b.textContent = '';
    var held = hold; hold = false;
    unlock();
    var o = opener; opener = null;
    // ux-pass16. back: the opener takes the focus, and the page does not move.
    function back() { if (o && o.focus && document.contains(o)) { try { o.focus({ preventScroll: true }); } catch (x) {} } }
    // Closed by another script that has put the focus on a field of the page (mbs:close with keep): it stays there.
    var at = document.activeElement;
    if (held && at && at !== o && at !== document.body && at !== document.documentElement) return;
    back();
    // An opener inside a bar that is not drawn while a dialog is open cannot take the focus yet. Once more two frames
    // later, when the bar is back, unless the focus has moved in between.
    at = document.activeElement;
    if (o && at !== o && window.requestAnimationFrame) window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { if (document.activeElement === at) back(); }); });
  }
  function open(t, from) {
    var d = D(), b = d && d.querySelector('[data-mbs-body]');
    if (!d || !b || !t || !t.content) return false;
    if (d.open) d.close();
    opener = from; y0 = window.scrollY;
    b.textContent = '';
    b.appendChild(t.content.cloneNode(true));
    // ux-pass30, a list sheet (snippets/mb-acc-engine): the card of the product the opener names (data-mbs-top) comes
    // first, then the cards of the group it names (data-mbs-first). The rest keep their order. Only the copy moves.
    var ls = b.querySelector('[data-mbs-list]'), k1 = ls && from && from.getAttribute ? from.getAttribute('data-mbs-first') : '', k2 = ls && from && from.getAttribute ? from.getAttribute('data-mbs-top') : '';
    if (k1 || k2) {
      var its = Array.prototype.slice.call(ls.children);
      its.filter(function (li) { return !!k2 && li.getAttribute('data-mbs-id') === k2; })
        .concat(its.filter(function (li) { return !!k1 && li.getAttribute('data-mbs-k') === k1 && !(k2 && li.getAttribute('data-mbs-id') === k2); }))
        .reverse().forEach(function (li) { ls.insertBefore(li, ls.firstChild); });
    }
    b.scrollTop = 0;
    if (ls) { amK = false; amList(); }
    // The main button of a product sheet goes into a bar that stays in view (CSS .mbs__bar).
    var go = b.querySelector('.mbs__p .mbs__go');
    if (go && go.parentNode) { var bar = document.createElement('div'); bar.className = 'mbs__bar'; go.parentNode.insertBefore(bar, go); bar.appendChild(go); }
    // The short form: an opener marked data-mbs-quick (the Add buttons of "You may also like").
    var quick = !!(from && from.hasAttribute && from.hasAttribute('data-mbs-quick') && b.querySelector('.mbs__p'));
    d.className = 'mbs mbs--' + (t.getAttribute('data-mbs-kind') || 'info') + (quick ? ' mbs--quick' : '');
    var h = b.querySelector('h2');
    if (h) { h.id = 'mbs-title'; h.setAttribute('tabindex', '-1'); d.setAttribute('aria-labelledby', 'mbs-title'); } else d.removeAttribute('aria-labelledby');
    // A link that must keep what the tapped row carried (the gift card amount).
    if (from && from.href) Array.prototype.forEach.call(b.querySelectorAll('a[data-mbs-href]'), function (a) { a.href = from.href; });
    if (!d.__mbs) { d.__mbs = 1; d.addEventListener('close', onClose); }
    var html = document.documentElement, w = window.innerWidth - html.clientWidth;
    old = { o: html.style.overflow, p: html.style.paddingRight };
    html.style.overflow = 'hidden';
    if (w > 0) html.style.paddingRight = w + 'px';
    d.showModal();
    // pass 62: the back color of a set sheet starts on the color picked on this page, when the set has it; the gallery
    // stays on its first photo.
    var bks = b.querySelector('[data-mbs-bks]');
    if (bks) {
      var pc = document.querySelector('input[data-option-name="Back color"]:checked'), cw = pc ? pc.value : '', cb = null;
      Array.prototype.forEach.call(bks.querySelectorAll('[data-mbs-bk]'), function (x) { if (!cb && cw && x.getAttribute('data-mbs-bk') === cw) cb = x; });
      if (cb) optPick(cb, d, true); else optSync(bks.closest('.mbs__txt') || b, d, true);
    }
    // The focus lands on the heading; a sheet without one keeps the close button.
    var x = h || d.querySelector('.mbs__x');
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    // no-exit follow-up (2026-10-13): every sheet starts at its top. The same line before showModal does nothing (a
    // closed sheet has no box to scroll), and a browser hands a reopened sheet the place the last one was left at.
    // The page sheets are long (the Tile Key), so the sheet opened after one of them started scrolled down.
    b.scrollTop = 0;
    // The short form shows the choice and the button at once; on a very short screen, scroll the sheet to them.
    if (quick) {
      var tg = b.querySelector('[data-mbs-form], .mbs__amts, .mbs__bar');
      if (tg) { var br = b.getBoundingClientRect(), tr = tg.getBoundingClientRect(); if (tr.bottom > br.bottom - 8) b.scrollTop = Math.max(0, Math.min(tr.bottom - br.bottom + 16, tr.top - br.top - 12)); }
    }
    return true;
  }
  // ux-pass33: the cart drawer and the cart icon come back with the add itself (Shopify renders their two sections into
  // the answer), so they are drawn without reading this whole page again. Without them the page is read as before.
  function secIds() {
    var a = [];
    (window.__mbCartDraw ? ['cart-drawer-component'] : ['cart-drawer-component', 'cart-icon']).forEach(function (n) { var e = document.querySelector(n), s = e && e.closest('.shopify-section'); if (s && s.id && a.indexOf(s.id) < 0) a.push(s.id); });
    return a.map(function (x) { return x.replace(/^shopify-section-/, ''); });
  }
  function withSec(o) { var a = secIds(); if (a.length) { o.sections = a.join(','); o.sections_url = location.pathname; } return o; }
  function secHtml(j) { var s = j && j.sections, a = secIds(), h = ''; if (!s || !a.length) return ''; for (var i = 0; i < a.length; i++) { if (typeof s[a[i]] !== 'string') return ''; h += s[a[i]]; } return h; }
  function paint(html) {
    if (window.__mbCartDraw) { window.__mbCartDraw(html, {}); return; } // pass 60: drawn in place (snippets/mb-cart-fix part 4)
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['cart-icon', 'cart-drawer-component'].forEach(function (n) { var nb = doc.querySelector(n), cb = document.querySelector(n); if (nb && cb) cb.innerHTML = nb.innerHTML; });
    } catch (x) {}
  }
  // pass 49 (2026-10-17) + 49b (2026-10-18, the owner: "tang giam so luong delay nen bam bi tut cam xuc"): after Add a
  // card of a list sheet shows a - n + stepper for its line. Every tap answers at once: the number she sees moves first,
  // the cart catches up behind, one request at a time per card (taps made meanwhile only move the target, q.__want).
  // The cart drawer and the cart icon are drawn again once the cart has settled. At 0 the line goes and Add comes back.
  // A new choice brings Add back: Add then makes a new line. pass 57: a note goes onto the line in her cart (noteSet).
  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' }, rpT = null, amN = 0, amK = false;
  function repaint() {
    clearTimeout(rpT);
    rpT = setTimeout(function () {
      var a = secIds(); if (!a.length) return;
      // No Accept header: with "application/json" a product URL answers with the product, not the sections.
      fetch(location.pathname + '?sections=' + a.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (s) { if (!s) return; var h = ''; a.forEach(function (x) { if (typeof s[x] === 'string') h += s[x]; }); if (h) paint(h); })
        .catch(function () {});
    }, 250);
  }
  function money(c) { c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  // The 10% of "2 or more add-ons" (snippets/mb-addon-multi) on the cards of the list sheet. With none of those add-ons
  // in the cart a card that takes part says "2+ save 10%" under its price; once the cart holds one, every such card
  // shows the price she pays for one more, with the regular price struck. Trinkets and rack birds keep a plain price.
  function amCard(li, ls) {
    ls = ls || li.closest('[data-mbs-list]');
    var pct = ls ? Number(ls.getAttribute('data-mbs-pct') || 0) : 0, pr = li.querySelector('[data-mbs-price]');
    if (!pr) return;
    var sel = li.querySelector('[data-mbs-var]'), o = sel && sel.options[sel.selectedIndex];
    var c = Number((o && o.getAttribute('data-cents')) || li.getAttribute('data-mbs-base') || 0);
    if (!c) return;
    // pass 52: a card whose product is marked down shows its compare-at struck (the choice's own, else the card's).
    var cmp = Number((o && o.getAttribute('data-cmp')) || li.getAttribute('data-mbs-cmp') || 0);
    if (!pct || !amK || !li.hasAttribute('data-mbs-am')) {
      if (cmp > c) pr.innerHTML = '<span class="mbsl__now">' + money(c) + '</span><s class="mbsl__was"><span class="mbs__sr">Regular price </span>' + money(cmp) + '</s>';
      else pr.textContent = money(c);
      return;
    }
    if (amN >= 1) pr.innerHTML = '<span class="mbsl__now">' + money(c - Math.round(c * pct / 100)) + '</span><s class="mbsl__was"><span class="mbs__sr">Regular price </span>' + money(c) + '</s>';
    else pr.innerHTML = money(c) + '<span class="mbsl__2p">2+ save ' + pct + '%</span>';
  }
  function amLs() { var d = D(); return d && d.querySelector('[data-mbs-list][data-mbs-pct]'); }
  function amPaint() { var ls = amLs(); if (!ls) return; Array.prototype.forEach.call(ls.querySelectorAll('.mbsl__card'), function (li) { amCard(li, ls); }); }
  function amCount(c) {
    var ls = amLs(); if (!ls || !c || !c.items) return;
    var ids = {}, n = 0;
    Array.prototype.forEach.call(ls.querySelectorAll('.mbsl__card[data-mbs-am]'), function (li) { ids[li.getAttribute('data-mbs-id')] = 1; });
    c.items.forEach(function (x) { if (ids[String(x.product_id)]) n += x.quantity; });
    amN = n; amK = true; amPaint();
  }
  function amList() {
    if (!amLs()) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: H }).then(function (r) { return r.ok ? r.json() : null; }).then(amCount).catch(function () {});
  }
  function nameOf(f) { var nm = f && f.querySelector('.mbsl__name'); return nm ? nm.textContent.trim() : 'It'; }
  function live(text) { var d = D(), lv = d && d.querySelector('[data-mbs-live]'); if (lv) lv.textContent = text; }
  function qtyMsg(f, text) { var m = f && f.querySelector('[data-mbs-msg]'); if (m) { m.textContent = text || ''; m.hidden = !text; } }
  function qtyShow(btn, f, n) {
    var q = f.querySelector('[data-mbs-qty]');
    if (!q) {
      var t = nameOf(f);
      q = document.createElement('span'); q.className = 'mbsl__qty'; q.setAttribute('data-mbs-qty', '');
      q.innerHTML = '<button type="button" class="mbsl__qb" data-mbs-qstep="-1"></button><span class="mbsl__qn"></span><button type="button" class="mbsl__qb" data-mbs-qstep="1"></button>';
      q.children[0].textContent = '\u2212'; q.children[0].setAttribute('aria-label', 'One less, ' + t);
      q.children[2].textContent = '+'; q.children[2].setAttribute('aria-label', 'One more, ' + t);
      btn.insertAdjacentElement('afterend', q);
    }
    q.__f = f; q.children[1].textContent = String(n);
    btn.hidden = true; btn.disabled = false; btn.removeAttribute('aria-busy');
    return q;
  }
  function qtyOff(f) {
    var q = f && f.querySelector('[data-mbs-qty]'), b = f && f.querySelector('[data-mbs-add]');
    if (q) q.remove();
    if (b && (b.hidden || b.disabled)) { b.hidden = false; b.disabled = false; b.removeAttribute('aria-busy'); if (b.__mbsH) b.innerHTML = b.__mbsH; }
  }
  // An answer of the old add path (a stay button that is not a list card): the same stepper.
  function qtyOn(btn, f, it) {
    if (!f || !it || !it.key || !btn.hasAttribute('data-mbs-stay')) return;
    var q = qtyShow(btn, f, it.quantity || 1); q.__key = it.key; q.__vid = it.variant_id; q.__props = JSON.stringify(it.properties || {});
  }
  // The line's key changes when a discount starts or stops applying to it (2 or more add-ons), so a line is found again
  // by its variant and its properties.
  function qtyLine(c, q) {
    var line = null;
    ((c && c.items) || []).forEach(function (x) { if (!line && ((q.__key && x.key === q.__key) || (x.variant_id === q.__vid && JSON.stringify(x.properties || {}) === q.__props))) line = x; });
    return line;
  }
  function qtySync(q) {
    if (q.__busy || q.__pending || q.__want == null) return;
    var want = q.__want, f = q.__f;
    q.__busy = true;
    function change(k) { return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ id: k, quantity: want }) }).then(function (r) { return r.ok ? r.json() : null; }); }
    function cart() { return fetch('/cart.js', { credentials: 'same-origin', headers: H }).then(function (r) { if (!r.ok) throw 0; return r.json(); }); }
    (q.__key ? change(q.__key) : Promise.resolve(null))
      .then(function (c) { return c || cart().then(function (c0) { var cur = qtyLine(c0, q); if (!cur) return c0; return change(cur.key).then(function (c2) { if (!c2) throw 0; return c2; }); }); })
      .then(function (c) {
        q.__busy = false;
        var line = qtyLine(c, q);
        q.__key = line ? line.key : null;
        amCount(c);
        if (q.__want !== want) { qtySync(q); return; }
        q.__want = null;
        repaint();
        if (!line) { if (q.isConnected) qtyOff(f); live(nameOf(f) + ' is out of your cart.'); return; }
        if (q.isConnected) q.children[1].textContent = String(line.quantity);
        live(nameOf(f) + ': ' + line.quantity + ' in your cart.');
      })
      .catch(function () {
        q.__busy = false; q.__want = null;
        qtyMsg(f, 'We could not change this. Please try again.');
        cart().then(function (c) { amCount(c); var line = qtyLine(c, q); q.__key = line ? line.key : null; if (!q.isConnected) return; if (!line) qtyOff(f); else q.children[1].textContent = String(line.quantity); }).catch(function () {});
      });
  }
  // pass 57: the note of a card whose line is in her cart (the stepper shows) goes onto that line: /cart/change.js with the
  // line's quantity and its properties, Note added, changed or taken off. It waits for the card's add or quantity change.
  function noteSet(q, v) {
    if (q.__busy || q.__pending) { setTimeout(function () { if (q.isConnected) noteSet(q, v); }, 150); return; }
    var props = {}, f = q.__f;
    try { props = JSON.parse(q.__props || '{}') || {}; } catch (x) { props = {}; }
    if ((props.Note || '') === v) return;
    if (v) props.Note = v; else delete props.Note;
    q.__busy = true;
    qtyMsg(f, '');
    fetch('/cart.js', { credentials: 'same-origin', headers: H })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (c) {
        var line = qtyLine(c, q);
        if (!line) throw 1;
        // A note taken off leaves the line with no property, which /cart/change.js cannot write: snippets/mb-cart-fix
        // (window.__mbSetProps, on every page with the drawer) adds the line again without it and takes the old one out.
        if (window.__mbSetProps) return window.__mbSetProps(line, props);
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); });
      })
      .then(function (c) {
        q.__busy = false;
        var line = null;
        ((c && c.items) || []).forEach(function (x) { if (!line && x.variant_id === q.__vid && ((x.properties || {}).Note || '') === v) line = x; });
        q.__key = line ? line.key : null;
        q.__props = JSON.stringify(line ? (line.properties || {}) : props);
        if (line && q.isConnected) q.children[1].textContent = String(line.quantity);
        amCount(c);
        repaint();
        live(nameOf(f) + (v ? ': note saved.' : ': note taken off.'));
        if (q.__want != null) qtySync(q);
      })
      .catch(function () {
        q.__busy = false;
        qtyMsg(f, 'We could not save the note. Please try again.');
        if (q.__want != null) qtySync(q);
      });
  }
  function qtyStep(b) {
    var q = b.closest('[data-mbs-qty]'), f = q && q.__f;
    if (!q || !f) return;
    var cur = q.__want != null ? q.__want : (Number(q.children[1].textContent) || 0);
    var want = Math.max(0, cur + (Number(b.getAttribute('data-mbs-qstep')) || 0));
    if (want === cur) return;
    q.__want = want;
    qtyMsg(f, '');
    if (f.hasAttribute('data-mbs-am') && amK) { amN = Math.max(0, amN + want - cur); amPaint(); }
    if (want === 0) { qtyOff(f); var bt = f.querySelector('[data-mbs-add]'); try { if (bt) bt.focus({ preventScroll: true }); } catch (x) {} }
    else q.children[1].textContent = String(want);
    qtySync(q);
  }
  // Add on a list card: the stepper shows at once with 1; the add runs behind (after the card's earlier request, if any).
  function addFast(btn, f, item) {
    var prev = f.__qq, q = qtyShow(btn, f, 1);
    f.__qq = q;
    q.__pending = true; q.__want = null; q.__key = null; q.__vid = item.id; q.__props = JSON.stringify(item.properties || {});
    qtyMsg(f, '');
    if (f.hasAttribute('data-mbs-am') && amK) { amN += 1; amPaint(); }
    live(nameOf(f) + ' is in your cart.');
    (function go() {
      if (prev && prev !== q && (prev.__busy || prev.__pending)) { setTimeout(go, 100); return; }
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (j) {
          var it = j && j.items && j.items[0];
          q.__pending = false;
          if (it) { q.__key = it.key; q.__vid = it.variant_id; q.__props = JSON.stringify(it.properties || {}); if (q.__want == null && q.isConnected) q.children[1].textContent = String(it.quantity); }
          if (q.__want != null) qtySync(q); else { repaint(); amList(); }
        })
        .catch(function () {
          q.__pending = false;
          if (f.hasAttribute('data-mbs-am') && amK) { amN = Math.max(0, amN - 1); amPaint(); }
          if (q.isConnected) qtyOff(f);
          qtyMsg(f, 'We could not add this. Please try again.');
        });
    })();
  }
  // A sheet button that adds one item right here: one request, no page load, she stays where she is.
  function addNow(btn, d) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var f = btn.closest('[data-mbs-form]'), sel = f && f.querySelector('[data-mbs-var]'), pick = d.querySelector('[data-mbs-amt]:checked');
    var id = Number(btn.getAttribute('data-mbs-add') || (sel && sel.value) || (pick && pick.value));
    var msg = (f && f.querySelector('[data-mbs-msg]')) || d.querySelector('[data-mbs-msg]'), err = f && f.querySelector('[data-mbs-err]'), stay = btn.hasAttribute('data-mbs-stay');
    if (!id) return;
    var item = { id: id, quantity: 1 }, props = {}, any = false, aj = null;
    function bad(text, el) {
      if (err) { err.textContent = text; err.hidden = false; }
      if (el) { if (el.type !== 'checkbox') el.setAttribute('aria-invalid', 'true'); try { el.focus(); } catch (x) {} }
    }
    if (f) {
      if (err) { err.hidden = true; err.textContent = ''; }
      // The name bag: never without a name of 1 to 20 characters and the ticked spelling box.
      var ne = f.querySelector('[data-mbs-name]'), tk = f.querySelector('[data-mbs-tick]');
      if (ne) {
        var nm = ne.value.trim();
        if (!nm || nm.length > 20) { bad('Please type the name to stitch.', ne); return; }
        // ux-pass41: letters (accents too), digits, spaces and & ' . - only, as on the product page.
        if (!(function () { try { return new RegExp("^[\\p{L}\\p{M}\\p{N} &'\\u2019.\\-]+$", 'u'); } catch (e) { return /^[A-Za-z\u00C0-\u024F0-9 &'\u2019.\-]+$/; } })().test(nm)) { bad('Letters, numbers and spaces only.', ne); return; }
        if (!tk || !tk.checked || !tk.value) { bad('Please tick the box to confirm the spelling.', tk); return; }
      }
      // pass 62: a personalized card (the Ornament, the Name Tag) never goes without its words and the ticked spelling box.
      var pz = f.querySelector('[data-mbs-pz]');
      if (pz) {
        if (!pz.value.trim()) { bad('Please type the words to print.', pz); return; }
        if (!tk || !tk.checked || !tk.value) { bad('Please tick the box to confirm the spelling.', tk); return; }
      }
      Array.prototype.forEach.call(f.querySelectorAll('[data-mbs-prop]'), function (el) {
        var k = el.getAttribute('data-mbs-prop'), v = el.type === 'checkbox' ? (el.checked ? el.value : '') : String(el.value || '').trim();
        if (k && v) { props[k] = v; any = true; }
      });
      if (any) item.properties = props;
    }
    if (stay && f && f.classList.contains('mbsl__card')) { addFast(btn, f, item); return; }
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(withSec({ items: [item] })) })
      .then(function (r) { if (!r.ok) throw 0; return r.json().then(function (j) { aj = j; return secHtml(j); }, function () { return ''; }); })
      .then(function (h) { return h || fetch(location.pathname, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } }).then(function (p) { return p.ok ? p.text() : ''; }); })
      .then(function (html) {
        // The cart icon and the cart drawer, redrawn from this page as the server now prints it.
        try {
          if (window.__mbCartDraw) window.__mbCartDraw(html, {}); // pass 60: drawn in place (snippets/mb-cart-fix part 4)
          else { var doc = new DOMParser().parseFromString(html, 'text/html');
          ['cart-icon', 'cart-drawer-component'].forEach(function (n) { var nb = doc.querySelector(n), cb = document.querySelector(n); if (nb && cb) cb.innerHTML = nb.innerHTML; }); }
        } catch (x) {}
        btn.removeAttribute('aria-busy'); if (stay && !btn.__mbsH) btn.__mbsH = btn.innerHTML; btn.textContent = stay ? 'Added' : 'Added to your cart'; btn.disabled = true;
        // ux-pass41: a row of the Extras box that opened this sheet (blocks/mb-offer-selector, [data-mbo-acc]) shows it is added:
        // its + box takes the ticked look and its second line reads Added.
        try { var xo = opener && opener.closest ? opener.closest('[data-mbo-acc]') : null, xb = xo ? xo.querySelector('.mbo__opt--btn') : null; if (xb) { xb.classList.add('is-added'); var xt = xb.querySelector('.mbo__opttxt'), xl = xt ? xt.querySelector('.mbo__optline') : null; if (xt && !xl) { xl = document.createElement('span'); xl.className = 'mbo__optline'; xt.appendChild(xl); } if (xl) xl.textContent = 'Added'; } } catch (x) {}
        // ux-pass30: a card of a list sheet says Added on its own button and the sheet stays open for one more thing.
        if (stay) { if (msg) msg.hidden = true; var lv = d.querySelector('[data-mbs-live]'), nm = f && f.querySelector('.mbsl__name'); if (lv) lv.textContent = (nm ? nm.textContent + ' is' : 'It is') + ' in your cart.'; qtyOn(btn, f, aj && aj.items && aj.items[0]); keepY = true; return; }
        if (msg) { msg.textContent = msg.getAttribute('data-mbs-ok') || 'It is in your cart. Keep choosing your set.'; msg.hidden = false; }
        keepY = true;
        // Close the sheet this button is in; a sheet she opened in the meantime stays.
        setTimeout(function () { if (document.contains(btn)) close(); }, 1400);
      })
      .catch(function () { btn.removeAttribute('aria-busy'); if (msg) { msg.textContent = 'We could not add this. Please try again.'; msg.hidden = false; } });
  }
  // pass 62: the size and back color rows of a set sheet. A tap presses one button of its row and names it in the
  // row's line; the hidden list of variants (a sheet that adds the set itself) or the second set's button follows.
  // Only a color tap moves the gallery, to its color slide. A color this size cannot have takes the size it comes in.
  function press(row, b, bk) {
    if (!row) return;
    Array.prototype.forEach.call(row.querySelectorAll(bk ? '[data-mbs-bk]' : '[data-mbs-szb]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var nm = row.querySelector(bk ? '[data-mbs-bkname]' : '[data-mbs-szname]');
    if (nm) nm.textContent = b.getAttribute(bk ? 'data-mbs-bk' : 'data-mbs-szb');
  }
  function optPick(b, d, quiet) {
    var bk = b.hasAttribute('data-mbs-bk'), row = b.closest(bk ? '[data-mbs-bks]' : '[data-mbs-szs]'), box = b.closest('.mbs__txt') || d;
    if (!row) return;
    press(row, b, bk);
    optSync(box, d, bk);
    if (bk) photoTo(d, b.getAttribute('data-img') || '', !quiet);
  }
  function optSync(box, d, colorFirst) {
    var bk = box.querySelector('[data-mbs-bk][aria-pressed="true"]'), sz = box.querySelector('[data-mbs-szb][aria-pressed="true"]');
    var c = bk ? bk.getAttribute('data-mbs-bk') : '', z = sz ? sz.getAttribute('data-mbs-szb') : '';
    var go = box.querySelector('[data-mbs-do]');
    if (go && go.hasAttribute('data-mbs-color')) go.setAttribute('data-mbs-color', c);
    var sel = box.querySelector('select[data-mbs-var][hidden]');
    if (!sel) return;
    var os = Array.prototype.slice.call(sel.options), pick = null;
    os.forEach(function (o) { if (!pick && (!c || o.getAttribute('data-bk') === c) && (!z || o.getAttribute('data-sz') === z)) pick = o; });
    if (!pick) os.forEach(function (o) { if (!pick && (colorFirst ? o.getAttribute('data-bk') === c : o.getAttribute('data-sz') === z)) pick = o; });
    if (!pick) return;
    var pz = pick.getAttribute('data-sz') || '', pc = pick.getAttribute('data-bk') || '';
    if (sz && pz !== z) Array.prototype.forEach.call(box.querySelectorAll('[data-mbs-szb]'), function (x) { if (x.getAttribute('data-mbs-szb') === pz) press(x.closest('[data-mbs-szs]'), x, false); });
    if (bk && pc !== c) Array.prototype.forEach.call(box.querySelectorAll('[data-mbs-bk]'), function (x) { if (x.getAttribute('data-mbs-bk') === pc) { press(x.closest('[data-mbs-bks]'), x, true); photoTo(d, x.getAttribute('data-img') || '', false); } });
    if (sel.value !== pick.value) { sel.value = pick.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  // pass 62: the photo of a choice. A sheet with a color slide (snippets/mb-sheet-photos) shows it there, its thumbnail
  // too, once the browser has it decoded (no blank frame), and moves to it when asked; a sheet without one swaps its
  // first photo as before.
  function jump(row, x) { try { row.scrollTo({ left: x, top: 0, behavior: 'instant' }); } catch (e) { row.scrollLeft = x; } }
  function photoTo(d, src, move) {
    var row = d && d.querySelector('.mbs__row'), cs = row && row.querySelector('[data-mbs-cslide]');
    if (!row) return;
    if (!cs) { var im0 = row.querySelector('.mbs__ph img'); if (im0 && src) im0.src = src; if (move) jump(row, 0); return; }
    var img = cs.querySelector('img'), th = d.querySelector('[data-mbs-cthumb] img'), i = Array.prototype.indexOf.call(row.children, cs);
    function put() { if (img && src && img.getAttribute('src') !== src) { img.loading = 'eager'; img.src = src; if (th) th.src = src; } if (move) jump(row, i * row.clientWidth); }
    if (!src || !img || img.getAttribute('src') === src) { put(); return; }
    var pre = new Image(), done = false, fin = function () { if (!done) { done = true; put(); } };
    pre.src = src;
    if (pre.decode) pre.decode().then(fin, fin); else pre.onload = pre.onerror = fin;
    setTimeout(fin, 400);
  }
  // The small form of a sheet: the color she picks sets the price on the button and the photo; the name counter.
  function field(e) {
    var d = D(), t = e.target;
    if (!d || !d.open || !t || !t.closest || !d.contains(t)) return;
    var f = t.closest('[data-mbs-form]');
    if (!f) return;
    if (t.hasAttribute('data-mbs-var')) {
      var o = t.options[t.selectedIndex], b = f.querySelector('[data-mbs-add]'), pr = f.querySelector('[data-mbs-price]') || d.querySelector('.mbs__price'), im = f.querySelector('[data-mbs-img]') || d.querySelector('.mbs__ph img'), row = d.querySelector('.mbs__row'), card = !!b && b.hasAttribute('data-mbs-stay');
      var price = o ? o.getAttribute('data-price') : '', src = o ? o.getAttribute('data-img') : '';
      if (card) { qtyOff(f); }
      else if (b && price && !b.disabled) b.textContent = (b.getAttribute('data-mbs-label') || 'Add to cart') + ' \u00b7 ' + price;
      // pass 62: a choice with a regular price shows it struck (the set and bag sheets); a card keeps its own price cell.
      if (pr && price) { var cm = o ? o.getAttribute('data-cmpm') : ''; if (cm && !card) pr.innerHTML = price + ' <s class="mbs__was"><span class="mbs__sr">Regular price </span>' + cm + '</s>'; else pr.textContent = price; }
      if (card) amCard(f);
      // pass 62: the photo of the choice goes to the sheet's color slide and the gallery moves there; a card swaps its own
      // photo. The hidden list of a set sheet follows the size and color buttons, which move the photo themselves.
      if (src && !t.hidden) { if (card) { if (im) im.src = src; } else photoTo(d, src, true); }
    }
    if (t.hasAttribute('data-mbs-name') && e.type === 'input') {
      var c = f.querySelector('[data-mbs-cnt]'), k = f.querySelector('[data-mbs-tick]'), er = f.querySelector('[data-mbs-err]');
      if (c) c.textContent = t.value.length + '/' + (t.getAttribute('maxlength') || 20);
      if (k && k.checked) k.checked = false;
      t.removeAttribute('aria-invalid');
      if (er) er.hidden = true;
    }
    // pass 62: the words of a personalized card (the Ornament, the Name Tag): typing takes the spelling tick off, as on the
    // name bag; a line already in her cart keeps its words, so Add comes back for the new ones.
    if (t.hasAttribute('data-mbs-pz') && e.type === 'input') {
      var pk = f.querySelector('[data-mbs-tick]'), pe = f.querySelector('[data-mbs-err]');
      if (pk && pk.checked) pk.checked = false;
      t.removeAttribute('aria-invalid');
      if (pe) pe.hidden = true;
      if (f.querySelector('[data-mbs-qty]')) qtyOff(f);
    }
    // pass 57 (audit 2026-10-18 #4): a note typed while the line is in her cart no longer brings Add back (the next Add
    // made a second line and hid the quantity in the cart); it goes onto that line when the field closes (noteSet).
    if (t.hasAttribute('data-mbs-tick') && t.checked) { var er2 = f.querySelector('[data-mbs-err]'); if (er2) er2.hidden = true; }
  }
  // ux-pass16: another script closes the sheet. detail.keep: the page stays where that script puts it, and a field
  // it has focused keeps the focus (onClose); without keep this is the close button.
  document.addEventListener('mbs:close', function (e) { var d = D(); if (!d || !d.open) return; hold = keepY = !!(e.detail && e.detail.keep); close(); });
  // Another script has scrolled the page behind the open sheet: the place to go back to moves with it.
  document.addEventListener('mbs:shift', function (e) { var d = D(), by = e.detail ? Number(e.detail.by) : 0; if (d && d.open && by) y0 += by; });
  // pass 49f (owner, 2026-10-18): the note field closes when she leaves it. Empty: the link "Add a note" comes back.
  // Filled: a quiet line "Note: ..." (tap to edit); the field keeps its value and goes with Add. A short wait lets a tap on
  // Add land before the row gets shorter.
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('mbsl__note')) return;
    setTimeout(function () {
      if (document.activeElement === t || !document.contains(t)) return;
      var nt = t.parentNode && t.parentNode.querySelector('[data-mbs-nt]');
      if (!nt) return;
      var v = String(t.value || '').trim();
      t.value = v; t.hidden = true;
      nt.textContent = v ? 'Note: ' + v : 'Add a note';
      nt.classList.toggle('is-set', !!v);
      nt.setAttribute('aria-expanded', 'false'); nt.hidden = false;
      var nf = t.closest('[data-mbs-form]'), nq = nf && nf.querySelector('[data-mbs-qty]');
      if (nq) noteSet(nq, v);
    }, 200);
  });
  // pass 65: the listing pop-up (assets/mb-qv.js) added a line from a card of this sheet: the card takes that choice, its
  // note or its words, and shows the - n + of that line, as after its own Add. The cart is drawn by the pop-up.
  document.addEventListener('mbqv:added', function (e) {
    var x = e.detail || {}, f = x.card, it = x.line, d = D();
    if (!f || !it || !it.key || !d || !d.open || !f.isConnected || !d.contains(f) || !f.classList.contains('mbsl__card')) return;
    var sel = f.querySelector('[data-mbs-var]'), btn = f.querySelector('[data-mbs-add]');
    if (!btn) return;
    if (sel && String(sel.value) !== String(it.variant_id)) { sel.value = String(it.variant_id); if (sel.value === String(it.variant_id)) field({ target: sel, type: 'change' }); }
    var pr = it.properties || {}, ni = f.querySelector('[data-mbs-prop="Note"]'), nt = f.querySelector('[data-mbs-nt]');
    if (ni && nt) { ni.value = pr.Note || ''; ni.hidden = true; nt.hidden = false; nt.textContent = ni.value ? 'Note: ' + ni.value : 'Add a note'; nt.classList.toggle('is-set', !!ni.value); nt.setAttribute('aria-expanded', 'false'); }
    var pz = f.querySelector('[data-mbs-pz]'), tk = f.querySelector('[data-mbs-tick]');
    if (pz) { pz.value = pr.Personalization || ''; pz.removeAttribute('aria-invalid'); }
    if (tk) tk.checked = !!pr['Spelling checked'];
    qtyOn(btn, f, it);
    live(nameOf(f) + ' is in your cart.');
    amList();
  });
  document.addEventListener('change', field);
  document.addEventListener('input', field);
  // Enter in the name field puts the keyboard away; it never sends anything.
  document.addEventListener('keydown', function (e) { var t = e.target; if (e.key === 'Enter' && t && t.hasAttribute && (t.hasAttribute('data-mbs-name') || (t.hasAttribute('data-mbs-prop') && t.type === 'text'))) { e.preventDefault(); t.blur(); } });
  // The card of the product she is looking at is not a link. The theme's card script reads data-no-navigation.
  function here() {
    tpls().forEach(function (t) {
      if (!t.hasAttribute('data-mbs-self')) return;
      var k = key(t.getAttribute('data-mbs-path'));
      Array.prototype.forEach.call(document.querySelectorAll('product-card a[href], .product-card a[href]'), function (a) {
        if (a.host !== location.host || key(a.pathname) !== k || !inZone(a)) return;
        var c = a.closest('product-card, .product-card');
        if (c) { c.setAttribute('data-no-navigation', ''); c.classList.add('mbs-here'); }
        a.setAttribute('data-mbs-here', '');
        a.removeAttribute('href');
      });
    });
  }
  // The quick add buttons are printed hidden: without this script the card is a plain link and needs no button.
  function quick() {
    if (!(D() && window.HTMLDialogElement && HTMLDialogElement.prototype.showModal)) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbs-quick][hidden]'), function (el) { if (byId(el.getAttribute('data-mbs-open'))) el.hidden = false; });
  }
  function ready() { here(); quick(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  function inside(e, d) {
    var t = e.target;
    if (t === d) { close(); return; }
    var c = t.closest('[data-mbs-close]');
    if (c) { e.preventDefault(); close(); return; }
    var nt = t.closest('[data-mbs-nt]');
    if (nt) { e.preventDefault(); var ni = nt.parentNode && nt.parentNode.querySelector('[data-mbs-prop="Note"]'); nt.hidden = true; nt.setAttribute('aria-expanded', 'true'); if (ni) { ni.hidden = false; try { ni.focus(); } catch (x) {} } return; }
    var qs = t.closest('[data-mbs-qstep]');
    if (qs) { e.preventDefault(); qtyStep(qs, d); return; }
    var ob = t.closest('[data-mbs-bk], [data-mbs-szb]');
    if (ob) { e.preventDefault(); optPick(ob, d); return; }
    var ad = t.closest('[data-mbs-add]');
    if (ad) { e.preventDefault(); addNow(ad, d); return; }
    var go = t.closest('[data-mbs-do]');
    if (go) {
      e.preventDefault();
      var v = go.getAttribute('data-mbs-do') || '', i = v.indexOf(':'), href = go.getAttribute('data-mbs-href') || '';
      var ev = new CustomEvent('mbs:do', { cancelable: true, detail: { name: i < 0 ? v : v.slice(0, i), value: i < 0 ? '' : v.slice(i + 1), color: go.getAttribute('data-mbs-color') || '' } }); // pass 62: color
      var taken = !document.dispatchEvent(ev);
      keepY = taken;
      close();
      // no-exit (pass 22): an action nobody took loads no page (it loaded the product's page, data-mbs-href). The sheet closes and she stays.
      return;
    }
    // no-exit (pass 22): no link inside a sheet loads a page or opens a tab. The sheets print none; one that a page body still carries does nothing.
    var ln = t.closest('a[href]');
    if (ln && d.contains(ln) && !ln.hasAttribute('download') && !/^(mailto|tel|sms):/i.test(ln.getAttribute('href') || '')) { e.preventDefault(); return; }
    var row = d.querySelector('.mbs__row'), ar = t.closest('[data-mbs-step]'), th = t.closest('[data-mbs-thumb]');
    if (row && ar) { e.preventDefault(); row.scrollBy(Number(ar.getAttribute('data-mbs-step')) * row.clientWidth, 0); }
    else if (row && th) { e.preventDefault(); row.scrollTo(Number(th.getAttribute('data-mbs-thumb')) * row.clientWidth, 0); }
  }
  document.addEventListener('click', function (e) {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.defaultPrevented) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var d = D();
    if (d && d.contains(t)) { if (d.open) inside(e, d); return; }
    var sc = t.closest('a[data-mbs-scroll]'), to = sc ? document.querySelector('.shopify-section[id$="__' + sc.getAttribute('data-mbs-scroll').replace(/[^a-z0-9_-]/gi, '') + '"]') : null;
    if (to) { e.preventDefault(); to.scrollIntoView({ block: 'start', behavior: window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); return; }
    var can = !!(d && window.HTMLDialogElement && HTMLDialogElement.prototype.showModal);
    var op = t.closest('[data-mbs-open]'), tp = null, from = op;
    if (op) tp = byId(op.getAttribute('data-mbs-open'));
    else {
      var card = t.closest('product-card, .product-card');
      // Her own card: no link, no load, nothing moves.
      if (card && card.classList.contains('mbs-here')) { if (!t.closest('button, input, label, select')) { e.preventDefault(); e.stopPropagation(); } return; }
      var a = t.closest('a[href]');
      if (!a && card) a = card.querySelector('a[href*="/products/"]');
      if (!a || !inZone(a)) return;
      var raw = a.getAttribute('href') || '';
      if (raw.charAt(0) === '#' || /^(mailto|tel|sms):/i.test(raw) || a.host !== location.host) return;
      tp = byPath(a.pathname); from = a;
      if (!tp || !can) {
        // no-exit (pass 22, widened in the follow-up): a page link of a zone that has no sheet loads nothing and opens no tab;
        // the tap does nothing. Every zone, and whatever target the link carries (it was the buy column only, and a
        // link with its own target was let through). Left to the browser: a download, a one-tap add, a link to this
        // very page and a cart link (its own script opens the cart drawer). A card's own script is stopped too.
        if (!tp && can && !a.hasAttribute('download') && !a.hasAttribute('data-mbc-add') && a.pathname !== location.pathname && !/\/cart(\/|$)/.test(a.pathname)) { e.preventDefault(); if (card) e.stopPropagation(); }
        return;
      }
    }
    // no-exit follow-up: an opener that is a link inside a zone and has no sheet on this page does nothing. Outside the
    // zones (the order-by bar of the header) it stays the plain link it is.
    if (!tp || !can) { if (!tp && can && op && op.tagName === 'A' && inZone(op)) e.preventDefault(); return; }
    e.preventDefault(); e.stopPropagation();
    if (tp.hasAttribute('data-mbs-self')) {
      // Her own card, tapped before here() ran: the same, nothing happens.
      if (from && from.closest && from.closest('product-card, .product-card')) return;
      var me = document.getElementById('mb-offers');
      if (me) me.scrollIntoView({ block: 'start', behavior: window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      return;
    }
    open(tp, from);
  }, true);
})();
